// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLOSE_WINDOW = "Zav\u0159i";
export const PRIVACY_LEAFLET_MORE_INFO = "V\u00edce informac\u00ed zde.";
export const PRIVACY_LEAFLET_ONE_LINER = "Pou\u017e\u00edv\u00e1me cookies.";
